import { render } from "./index.vue?vue&type=template&id=b2aef3f6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-listing-list/standard/components/content/index.vue'],['render',render],['__file',"index.vue"]])

export default __exports__